import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    IconButton,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Icons, toast } from "react-toastify";
import Loader from "../../components/Loader";
// import { IMAGE_URL } from "../../store/services/constants";
import { useEditCategoryMutation } from "../../store/services/categoriesService";
import { IMAGE_URL } from "../../Api/constants";



const labelStyle = {
    fontFamily: "PSBo",
    fontSize: 15,
    color: "#333",
    mb: 0.5,
};

const EditCategoryDialog = ({ open, onClose, data }) => {

    const words = useSelector((state) => state.authReducer.words);
    const [editCategory, { isLoading, isError }] = useEditCategoryMutation();

    const [formValues, setFormValues] = useState({
        name: data.name ?? "",
        ar_name: data.ar_name ?? "",
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [image, setImage] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
        } else {
            toast.error("Please upload a valid PNG file.");
        }
    };

    const handleSubmit = async () => {
        if (!formValues.name) {
            toast.error("Please fill in all required fields.");
            return;
        }

        const formData = new FormData();
        formData.append("name", formValues.name);
        formData.append("ar_name", formValues.ar_name);
        formData.append("id", data.id);
        if (selectedFile) {
            formData.append("image", selectedFile);
        }

        try {
            await editCategory({ formData }).unwrap();
            toast.success("Category updated successfully.");
            onClose()
        } catch (error) {
            toast.error("Failed to update category.");
        }



    };

    useEffect(() => {
        if (data) {
            setFormValues({
                name: data.name ?? "",
            });
            setImage(IMAGE_URL + data.image);
        }
    }, [data]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Loader open={isLoading} />

            <DialogTitle sx={{ fontFamily: "PSBo", fontSize: 18, color: "#333" }}>
                {words["Edit Category"]}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {/* Form Fields */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} display="flex" flexDirection="row" justifyContent="space-between">
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                            <Box
                                sx={{
                                    width: "95px",
                                    height: "95px",
                                    borderRadius: "50px",
                                    border: "1px dashed #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    textAlign: "center",
                                    color: "#999",
                                    backgroundColor: "#E6E6E6",
                                    cursor: "pointer",
                                    position: "relative",
                                }}
                                onClick={() => document.getElementById("profileImageUpload").click()}
                            >
                                {selectedFile ? (
                                    <img
                                        src={URL.createObjectURL(selectedFile)}
                                        alt="Profile Preview"

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : image ? (
                                    <img

                                        style={{
                                            width: "95px",
                                            height: "95px",
                                            borderRadius: "50px",
                                        }}
                                        src={image}
                                    />
                                ) : (
                                    <Icons.imageUplaodIcon />
                                )}
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    ml: 1,
                                }}
                            >
                                <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                    Upload the Image
                                </Typography>
                                <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                    150x150 pixel
                                </Typography>
                            </Box>
                        </Box>
                        <input
                            type="file"
                            id="profileImageUpload"
                            accept=".png,.jpg,.jpeg"

                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                    </Grid>
                    {/* Other Fields */}
                    <Grid item xs={12} sm={6}>
                        <Typography sx={labelStyle}>{words["Name"]}*</Typography>
                        <TextField
                            fullWidth
                            name="name"
                            value={formValues.name}
                            onChange={handleInputChange}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography sx={labelStyle}>{words["Arabic Name"]}*</Typography>
                        <TextField
                            fullWidth
                            name="ar_name"
                            value={formValues.ar_name}
                            onChange={handleInputChange}
                            required
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: "20px", fontSize: 12 }}>
                    {words["Cancel"]}
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    // disabled={isLoading}
                    sx={{
                        // backgroundColor: colors.primary,
                        fontSize: 12,
                        color: "white",
                        borderRadius: "20px",
                        padding: "8px 26px",
                    }}
                >
                    Submit
                    {/* {isLoading ? "Submitting..." : words["Submit"]} */}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditCategoryDialog;